import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

import { DataBlocks, I18n } from 'components';
import { InsurancePolicy } from '../InsurancePolicy';

import styles from './styles.pcss';
import { policeShape } from '../../shapes';

const cx = classNames.bind(styles);

export const CurrentInsurance = ({ policies, presetUrl, fullPrice }) => (
  <DataBlocks.Container className={cx('page')}>
    <DataBlocks.Block
      title={(
        <>
          <I18n
            className={cx('blockTitle')}
            path="insurance.blockTitle"
          />
          <img
            className={cx('alfastrahLogo')}
            src="http://static.beeline.ru/upload/images/mlk/images/alfastrah.svg"
            alt="Альфа страхование"
          />
        </>
        )}
      info={fullPrice > 0 && (
      <span className={cx('price')}>
        {fullPrice}
        {' '}
        ₽ в месяц
      </span>
      )}
    >
      <div className={cx('policies')}>
        {policies.map((policy) => (
          <InsurancePolicy key={policy.number} {...policy} presetUrl={presetUrl} />
        ))}
      </div>
      <div className={cx('helpMessage')}>
        <img
          className={cx('helpMessageIcon')}
          src="//static.beeline.ru/upload/images/emoji/phone.svg"
          alt=""
        />
        <I18n path="insurance.helpMessage" />
      </div>
    </DataBlocks.Block>
  </DataBlocks.Container>
);

CurrentInsurance.propTypes = {
  presetUrl: PropTypes.string,
  policies: PropTypes.arrayOf(PropTypes.shape(policeShape)),
  fullPrice: PropTypes.number,
};
